import { Location } from '@cobliteam/common-types';

import { lazy } from '@cobliteam/lazy-with-retries';

const ChecklistsPage = lazy(() => import('../pages/ChecklistsPage'));
const ChecklistPageDashboard = lazy(() => import('../pages/ChecklistPageDashboard'));
const ChecklistPageResponse = lazy(() => import('../pages/ChecklistPageResponse'));
const ChecklistPageAll = lazy(() => import('../pages/ChecklistPageAll'));
const ChecklistPageAllResponses = lazy(() => import('../pages/ChecklistPageAllResponses'));

export interface IRoute {
  path: string;
  team?: string;
  component: any;
  accessDeniedDescription: string;
  routes?: IRoute[];
  exact?: boolean;
}

const routes: IRoute[] = [
  {
    path: Location.CHECKLIST_RESPONSE,
    team: 'squad-gf-core',
    component: ChecklistPageResponse,
    accessDeniedDescription: 'ver respostas de checklists',
    exact: true,
  },
  {
    path: Location.CHECKLIST,
    team: 'squad-gf-core',
    component: ChecklistsPage,
    accessDeniedDescription: 'ver checklists',
    routes: [
      {
        path: Location.CHECKLIST_DASHBOARD,
        component: ChecklistPageDashboard,
        accessDeniedDescription: 'ver análises de checklists',
        exact: true,
      },
      {
        path: Location.CHECKLIST_ALL,
        component: ChecklistPageAll,
        accessDeniedDescription: 'ver todos os checklists',
        exact: true,
      },
      {
        path: Location.CHECKLIST_ALL_RESPONSES,
        component: ChecklistPageAllResponses,
        accessDeniedDescription: 'ver todas as respostas de checklists',
        exact: true,
      },
    ],
  },
];

export default routes;
